import React from 'react';
import styled from 'styled-components';
import { RoomItem, DeleteButton } from "./styled/ChatComponents";

const formatRoomName = (name) => {
  if (!name) return '';

  // Split by underscore or space
  const words = name.split(/[_\s]+/);

  // Capitalize first letter of each word and join with spaces
  const formatted = words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

  // Truncate if too long
  return formatted.length > 30 ? 
    formatted.substring(0, 27) + '...' : 
    formatted;
};

const ChatRoomList = ({ rooms, selectedId, onSelect, onDelete, onPageChange }) => {
  const { chat_topics, page, next_page, prev_page, total_records, per_page
  } = rooms;
  console.log('chat_topics', chat_topics);
    const totalRecordsNumber = Number(total_records);
  return (
    <Container>
      <RoomsList>
        {chat_topics && chat_topics.map((room) => (
          <RoomItem
            key={room.id}
            selected={room.id === selectedId}
            onClick={() => onSelect(room.id)}
          >
            <RoomName title={room.name}>
              {room.id} # {formatRoomName(room.name)}
            </RoomName>
            <DeleteButton
              onClick={(e) => {
                e.stopPropagation();
                onDelete(room.id);
              }}
            >
              ×
            </DeleteButton>
          </RoomItem>
        ))}
      </RoomsList>
      <Pagination>
        <PageButton disabled={!prev_page} onClick={() => onPageChange(page - 1)}>
          Previous
        </PageButton>
        <PageInfo>
          Page {page} of {Math.ceil(totalRecordsNumber / (per_page || 12))}
        </PageInfo>
        <PageButton disabled={!next_page} onClick={() => onPageChange(page + 1)}>
          Next
        </PageButton>
      </Pagination>
    </Container>
  );
};

export default ChatRoomList;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const RoomsList = styled.div`
  overflow-y: auto;
  flex: 1;
`;

const RoomName = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Pagination = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px;
`;

const PageButton = styled.button`
  padding: 5px 10px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

const PageInfo = styled.span`
  align-self: center;
`;